import React from "react";
import helpPopout from "../../assets/help/help-popout.svg";
import closeHelp from "../../assets/help/help-close.svg";
import "./Help.scss";

function Help(props) {
  return (
    <div className="help">
      <div className="help-container">
        <img src={helpPopout} className="help-popout" alt="help pop-out" />;
      </div>
      <div
        className="help-close-container"
        onClick={() => props.setShowHelp(false)}
      >
        <img src={closeHelp} className="help-close" alt="help close" />
      </div>
    </div>
  );
}

export default Help;
